module.exports = __webpack_public_path__ + "img/visiolens_logo.ab0b1df7.png";